module.exports = __webpack_public_path__ + "static/media/discount_offer.a57a1c31.svg";